import { useState, useEffect, useRef } from 'react'
import { withTheme } from 'emotion-theming'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'

import Image from 'components/Image'
import { SimpleImg } from 'react-simple-img'

import style from './Tabs.style'

const TabsStyled = styled.div(props => ({ ...style(props) }))

export const Tabs = ({ data }) => {
    const [activeTab, setActiveTab] = useState(1)
    const [tabWidth, setTabWidth] = useState(100)
    const [tabOffset, setTabOffset] = useState(100)

    const activeTabElement = useRef()
    const tabIndicatorWrap = useRef()

    const activeDoneTab = id => {
        let classNames = 'Tab '

        if (id === activeTab) {
            classNames += 'TabSelected'
        }

        if (id < activeTab) {
            classNames += 'TabDone'
        }

        return classNames
    }

    useEffect(() => {
        const indicatorOffset = tabIndicatorWrap.current.getBoundingClientRect().left

        setTabWidth(activeTabElement.current.getBoundingClientRect().width)
        setTabOffset(activeTabElement.current.getBoundingClientRect().left - indicatorOffset)
    }, [activeTab])

    return (
        <TabsStyled numTabs={data.length} tabWidth={tabWidth} tabOffset={tabOffset} activeTab={activeTab}>
            <div className="TabHeadlines">
                {data.map(item => (
                    <button
                        key={`${item.id}-tab`}
                        type="button"
                        className={activeDoneTab(item.id)}
                        onClick={() => setActiveTab(item.id)}
                        ref={item.id === activeTab ? activeTabElement : null}>
                        <span className="Number">{item.id}</span> <span className="Headline">{item.title}</span>
                    </button>
                ))}
            </div>

            <div className="TabIndicatorWrap" ref={tabIndicatorWrap}>
                <span className="TabIndicator" />
            </div>

            {data.map(item => (
                <div key={`${item.id}-panel`} className={`${item.id === activeTab ? 'show' : 'hide'}`}>
                    <div className="TabPanel">
                        <span className="Headline">{item.title}</span>
                        <div className="Content">{item.content}</div>
                        <div className="Image">
                            <SimpleImg src={item.image} alt="Tab" />
                        </div>
                    </div>
                </div>
            ))}
        </TabsStyled>
    )
}

Tabs.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            title: PropTypes.string,
            content: PropTypes.string,
            image: PropTypes.string
        })
    )
}

Tabs.defaultProps = {
    data: []
}

export default withTheme(Tabs)
